import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: [
		'LandingLanguageButton',
		'LandingHead',
		'LandingTitle',
		'LandingLottieAnimation',
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('pages.landing.title_activity'),
			size: 'small',
			customStyles: {
				marginLeft: '3rem',
				marginRight: '3rem',
			},
		}),

		LandingLottieAnimation: (): LandingComponentsConfig['LandingLottieAnimation'] => ({
			animationData: require('@/data/lottie-animations/genderSelectionLoader.json'),
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
